module.exports = __webpack_public_path__ + "static/media/legadosemente-header-background.7299683a.png";